var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"terminal-dialog common-dialog",attrs:{"close-on-click-modal":false,"visible":_vm.dialogVisible,"before-close":_vm.handleCancel,"title":_vm.title,"top":"25vh"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('terminal-board',{ref:"terminalDialog",attrs:{"id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }